import * as i0 from "@angular/core";
export class NgModelChangeDebouncedModule {
}
NgModelChangeDebouncedModule.ɵfac = function NgModelChangeDebouncedModule_Factory(t) { return new (t || NgModelChangeDebouncedModule)(); };
NgModelChangeDebouncedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: NgModelChangeDebouncedModule });
NgModelChangeDebouncedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
